import classnames from 'classnames';
import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';
import React from 'react';
import formatDate from 'utils/formatDate';
import { TODAY } from '~/timeConstants';

const CSS = require('./DatePickerDay.module.scss');

interface DatePickerDayProps {
  day: Date;
  selectedDay?: Date;
  onDateChange: (newDate: string) => void;
  isUnavailable?: boolean;
  isPreferredAvailable?: boolean;
  variant: 'pink' | 'jade';
}

function DatePickerDay({
  day,
  selectedDay,
  onDateChange,
  isUnavailable,
  isPreferredAvailable,
  variant,
}: DatePickerDayProps) {
  const isDayToday = isSameDay(day, TODAY);
  const isDayBeforeToday = isBefore(day, TODAY) && !isDayToday;
  const isDaySelected = selectedDay ? isSameDay(day, selectedDay) : false;
  const formattedDate = formatDate(day, 'yyyy-MM-dd');

  const onDay = () => onDateChange(formattedDate);

  const isDisabled = (isDayBeforeToday && !isDayToday) || isUnavailable;
  return (
    <time dateTime={formattedDate} className={CSS.DayContainer}>
      <button
        type="button"
        className={classnames(CSS.Day, {
          [CSS.Disabled]: isDisabled,
          [CSS.Today]: isDayToday,
          [CSS.SelectedDay]: isDaySelected,
          [CSS.PreferredAvailable]: isPreferredAvailable,
        })}
        disabled={isDisabled}
        onClick={onDay}
        data-date={formattedDate}
        data-variant={variant}
        data-test-id={`datepicker-day-${
          isDisabled ? 'unavailable' : 'available'
        }`}
      >
        {formatDate(day, 'd')}
      </button>
    </time>
  );
}

export default DatePickerDay;
